export enum GenderEnum {
  male = 'MALE',
  female = 'FEMALE',
  other = 'OTHER',
  unknown = 'UNKNOWN',
}
